import * as Sentry from '@sentry/browser';

// eslint-disable-next-line no-console
export const debug = console.debug;
const ERROR_PAGE_TAG = 'triggered-error-page';
const ERROR_PAGE_LEVEL = 'fatal';
const INFO_LEVEL = 'info';

export function logErrorPage(error) {
    Sentry.withScope((scope) => {
        scope.setTag(ERROR_PAGE_TAG, true);
        scope.setLevel(ERROR_PAGE_LEVEL);
        Sentry.captureException(error);
    });
}

export function logInfo(error, tag, extra) {
    Sentry.withScope((scope) => {
        scope.setTag(tag, true);
        scope.setLevel(INFO_LEVEL);
        extra.forEach(({ key, value }) => {
            scope.setExtra(key, value);
        });
        Sentry.captureException(error);
    });
}
